import { MetacomDataDTO } from "@core/models/dto.models";
import { Action, ActionReducer } from "@ngrx/store";

//Rehydration
export function rehydrateState<S>(key: string, initialState: S): S {
  const savedState = localStorage.getItem(key);
  return savedState ? JSON.parse(savedState) : initialState;
}

export function persistState<S>(key: string, state: S): void {
  localStorage.setItem(key, JSON.stringify(state));
}

export function createRehydrateReducer<S, A extends Action<string>>(
  key: string,
  reducer: ActionReducer<S, A>,
  initialState: S
): ActionReducer<S, A> {
  const rehydratedState = rehydrateState<S>(key, initialState);

  return (state: S | undefined, action: A): S => {
    const currentState = state || rehydratedState; // Use rehydrated state if state is undefined
    const nextState = reducer(currentState, action);
    persistState(key, nextState); // Save to local storage after processing
    return nextState;
  };
}

//Metacom rehydration

export function metacomCreateRehydrateReducer<
  S extends { data: MetacomDataDTO },
  A extends Action<string>
>(
  key: string,
  reducer: ActionReducer<S, A>,
  initialState: S
): ActionReducer<S, A> {
  const rehydratedState = metacomRehydrateState<S>(key, initialState);

  return (state: S | undefined, action: A): S => {
    const currentState = state || rehydratedState; // Use rehydrated state if state is undefined
    const nextState = reducer(currentState, action);
    persistState(key, nextState); // Save to local storage after processing
    return nextState;
  };
}

export function metacomRehydrateState<S extends { data: MetacomDataDTO }>(
  key: string,
  initialState: S
): S {
  const savedState = localStorage.getItem(key);
  if (savedState) {
    const rehydratedData = JSON.parse(savedState);
    // Only return the 'data' field, keeping the rest of the state as is

    return {
      ...initialState,
      data: rehydratedData?.data || initialState.data, // Restore only the 'data' part
    };
  }
  return initialState; // Return the initial state if nothing is saved
}
